import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const MainPageTaxConsent = lazy(() => import('./MainPageTaxConsent'));
const Success = lazy(() => import('./Success'));
const Footer = lazy(() => import('./components/Footer'));

function TaxConsent() {
    return (
        <>
            <Suspense fallback={null}>
                <Routes>
                    <Route path="/" element={<MainPageTaxConsent />} />
                    <Route path="success" element={<Success />} />
                </Routes>
                <Footer />
            </Suspense>
        </>
    );
}

export default TaxConsent;
